export enum TransferState {
  INCOMING = 'incoming',
  OUTGOING = 'outgoing',
  CONNECTING = 'connecting',
  CONNECTED = 'connected',
  IN_PROGRESS = 'inProgress',
  COMPLETE = 'complete',
  FAILED = 'failed',
}
